/* stylelint-disable selector-max-compound-selectors */
@import '../../../node_modules/leaflet/dist/leaflet.css';
@import '../../../node_modules/leaflet.markercluster/dist/MarkerCluster.css';
@import '../../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css';

@import '../../sass/bootstrap/pre-default';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';
@import '../../sass/colors';
@import '../../sass/spacers';

@mixin leaflet-control {
  background-color: $vtd-blue-600;
  border: 1px solid $vtd-blue-800 !important;
  border-radius: 4px !important;
  color: $vt-white;
  font-size: 27px !important;
  height: 40px !important;
  line-height: 40px !important;
  margin-bottom: 8px;
  width: 40px !important;

  &:active {
    background-color: $vtd-blue-600;
  }

  &:hover:not(.leaflet-disabled) {
    /* stylelint-disable-next-line scss/no-global-function-names */
    background-color: darken($vtd-blue-600, 10%) !important;
    color: $vt-white !important;
  }
}

$inner-circle-color: $vtd-blue-1000;
$outer-circle-color: $vtd-blue-600;

.map-component {
  .leaflet-control-zoom {
    border: none !important; /* stylelint-disable-line declaration-property-value-disallowed-list */

    .leaflet-control-zoom-in,
    .leaflet-control-zoom-out {
      @include leaflet-control;
    }

    .leaflet-disabled {
      border: none !important; /* stylelint-disable-line declaration-property-value-disallowed-list */
    }
  }

  .leaflet-my-position {
    cursor: pointer;
    position: relative;

    @include leaflet-control;

    > img {
      height: 22px;
      left: 9px;
      position: absolute;
      top: 9px;
      width: 22px;
    }

    &.active {
      /* stylelint-disable-next-line scss/no-global-function-names */
      background-color: darken($vtd-blue-600, 10%) !important;
    }
  }

  .leaflet-right {
    z-index: auto;
  }

  .leaflet-container {
    font-family: $font-family-base;
    font-size: $font-size-base;

    a {
      color: $vt-link-color;
    }
  }

  // for stopareasearchpage
  .leaflet-popup-content {
    max-width: 14.375rem;
    width: 14.375rem;
  }

  .leaflet-pane {
    .map-marker-icon {
      position: relative;

      > img {
        height: 100%;
        width: 100%;
      }

      > span {
        color: $vt-white;
        left: 50%;
        position: absolute;
        top: 2px;
        transform: translate(-50%, 0);
      }
    }
  }

  .leaflet-popup-pane {
    .leaflet-popup {
      .leaflet-popup-close-button {
        color: $vt-black;
        font-size: 1.25rem;
        font-weight: normal;
        padding: $spacer-2 $spacer-3 0 0;
        width: 1.625rem;
      }

      .leaflet-popup-content-wrapper {
        .leaflet-popup-content {
          // Copied from line-icon.component.scss, 2019-05-06
          .line-icon-component {
            border: 1px solid transparent;
            min-height: 1.5rem;
            min-width: 2rem;
            padding: 0.1rem 0.3rem;
            width: auto;

            &.border-on-white-background {
              border: 1px solid $vtd-gray-300;
            }
          }

          // Copied from _spinner.scss, 2019-05-07 (just converted px to rem)
          .spinner-container {
            align-items: center;
            display: flex;
            justify-content: center;
            /* stylelint-disable-next-line */
            & > .spinner {
              animation: spin 1.1s linear infinite;
              border: 0.3125rem solid $vtd-blue-600;
              border-bottom-color: transparent;
              border-radius: 100%;
              display: inline-block;
              height: 2.5rem;
              width: 2.5rem;
            }
          }

          .hide-overflow-lines {
            height: 1.875rem;
            overflow: hidden;
            width: 10.625rem;
          }

          .lines-container {
            width: 14.375rem;
          }
        }
      }
    }
  }

  /* Default icon URLs */
  .leaflet-default-icon-path {
    background-image: none;
  }

  .leaflet-default-shadow-path {
    background-image: none;
  }

  // markerCluster overrides
  .marker-cluster-small {
    background-color: $outer-circle-color;
  }

  .marker-cluster-small div {
    background-color: $inner-circle-color;
  }

  .marker-cluster-medium {
    background-color: $outer-circle-color;
  }

  .marker-cluster-medium div {
    background-color: $inner-circle-color;
  }

  .marker-cluster-large {
    background-color: $outer-circle-color;
    border-radius: 1.875rem !important;
    height: 3.125rem !important;
    width: 3.125rem !important;

    div {
      background-color: $inner-circle-color;
      border-radius: 1.25rem;
      font-size: 1rem !important;
      height: 2.5rem;
      width: 2.5rem;
    }

    /* stylelint-disable-next-line no-descending-specificity */
    span {
      line-height: 2.375rem !important;
    }
  }

  /* IE 6-8 fallback colors */
  .leaflet-oldie .marker-cluster-small {
    background-color: $outer-circle-color;
  }

  .leaflet-oldie .marker-cluster-small div {
    background-color: $inner-circle-color;
  }

  .leaflet-oldie .marker-cluster-medium {
    background-color: $outer-circle-color;
  }

  .leaflet-oldie .marker-cluster-medium div {
    background-color: $inner-circle-color;
  }

  .leaflet-oldie .marker-cluster-large {
    background-color: $outer-circle-color;
  }

  .leaflet-oldie .marker-cluster-large div {
    background-color: $inner-circle-color;
  }

  /* stylelint-disable-next-line no-descending-specificity */
  .marker-cluster div {
    color: $vt-white;
    /* stylelint-disable-next-line font-family-name-quotes */
    font-family: 'kollektiv-text', Arial, Helvetica, sans-serif;
  }
}
